const voiceContext = require.context('../assets/mascot/audio', false, /\.mp3$/);

function normalizeKey(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/\.mp3$/i, '')
    .replace(/^\.\//, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

const VOICE_CLIPS = voiceContext.keys().map((key) => ({
  key,
  label: normalizeKey(key),
  url: voiceContext(key),
}));

const GROUP_MATCHERS = {
  delete: [
    'bereinigt',
    'fehler',
    'eintrag uber',
    'kurs korigiert',
    'kein drama',
    'streicht',
    'korrigert',
    'ordnung',
    'weg damit',
    'echte beute',
  ],
  add: [
    'fund gesichert',
    'pfand an deck',
    'rein damit',
    'bares gold',
    'riecht pfand',
    'flasche gehort',
    'schatzkasse',
    'kein zufall',
    'sammler',
    'stuck beute',
  ],
  expedition: [
    'karte',
    'kompass',
    'kurs setzen',
    'draussen wartet',
    'route',
    'horizont',
    'nebel',
    'spur wird heiss',
    'naher am grossen fund',
  ],
  big: [
    'fett',
    'legend',
    'augen machen',
    'goldig',
    'funkeln',
    'nicht alle tage',
    'moment furs logbuch',
    'richtigen riecher',
    'hafen flustert',
    'schatzkiste',
  ],
  loot: [
    'glitzert',
    'seltene',
    'spur gfunden',
    'wertvoll',
    'schatzgeruch',
    'kiste ruft',
    'staub',
    'pfoten',
    'magie',
    'crew material',
    'schatz funkelt',
    'entdeckung',
    'hafen gibt',
    'jackpor',
  ],
  xp: [
    'gibt xp',
    'crew kasse',
    'hehe gute',
    'flasche gesichert',
    'crew hebt',
    'beute an board',
    'nickt zufrieden',
    'flotter fang',
    'hafen merkt',
    'zack fund',
    'sauber',
    'staerker',
    'kleiner fund',
  ],
};

const CLIPS_BY_GROUP = Object.entries(GROUP_MATCHERS).reduce((groups, [group, matchers]) => {
  groups[group] = VOICE_CLIPS.filter((clip) => matchers.some((matcher) => clip.label.includes(matcher)));
  return groups;
}, {});

const QUICK_MARK_GROUPS = ['single', 'multiple', 'bag', 'crate', 'einwegpfand', 'mehrwegpfand', 'gemischtes_pfand', 'giveaway'];
const QUICK_MARK_CLIPS = QUICK_MARK_GROUPS.reduce((groups, group) => {
  groups[group] = VOICE_CLIPS.filter((clip) => clip.label.includes(`quick mark ${group}`));
  return groups;
}, {});

function stableIndex(seed, length) {
  if (!length) return 0;
  const source = String(seed || '');
  let hash = 0;
  for (let index = 0; index < source.length; index += 1) {
    hash = (hash * 31 + source.charCodeAt(index)) >>> 0;
  }
  return hash % length;
}

function pickClip(group, seed) {
  const clips = CLIPS_BY_GROUP[group] || [];
  if (!clips.length) return '';
  return clips[stableIndex(seed, clips.length)]?.url || '';
}

function pickQuickMarkClip(change = {}) {
  const amountGroup = String(change?.amount_group || change?.amountGroup || change?.amount_type || change?.amountType || '').trim();
  const group = QUICK_MARK_GROUPS.includes(amountGroup) ? amountGroup : 'single';
  const clips = QUICK_MARK_CLIPS[group] || [];
  if (!clips.length) return '';
  return clips[stableIndex(`${group}:${change?.id || ''}:${change?.post_id || ''}:${change?.xp || ''}`, clips.length)]?.url || '';
}

function pickByLine(line) {
  const normalized = normalizeKey(line);
  if (!normalized) return '';

  const exact = VOICE_CLIPS.find((clip) => clip.label === normalized);
  if (exact) return exact.url;

  const partial = VOICE_CLIPS.find((clip) => (
    normalized.includes(clip.label) || clip.label.includes(normalized)
  ));
  return partial?.url || '';
}

function resolveXpGroup(change = {}) {
  const event = String(change?.event || '');
  const awarded = Number(change?.awarded || 0);

  if (awarded < 0 || event === 'remove_entry') return 'delete';
  if (event === 'add_pfand' || event === 'freitext' || event === 'barcode_scan') return 'add';
  if (event.includes('map') || event.includes('fragment') || event.includes('expedition')) return 'expedition';
  if (event.includes('loot') || event.includes('bottle_message')) return 'loot';
  if (awarded >= 50 || event.includes('level') || event.includes('boost') || event.includes('goal')) return 'big';
  return 'xp';
}

export function getKorkXpAudio(change, line = '') {
  if (String(change?.event || '') === 'mark_pfandspende') {
    const quickMarkClip = pickQuickMarkClip(change);
    if (quickMarkClip) return quickMarkClip;
  }

  const byLine = pickByLine(line);
  if (byLine) return byLine;

  const group = resolveXpGroup(change);
  return pickClip(group, `${group}:${change?.event || ''}:${change?.id || ''}:${change?.xp || ''}`);
}

export function getKorkMomentAudio(moment) {
  const type = String(moment?.type || '');
  const rarity = String(moment?.rarity || '');
  let group = 'xp';

  if (type.includes('map') || type.includes('fragment') || type.includes('expedition')) {
    group = 'expedition';
  } else if (type.includes('loot') || type.includes('pfand_beifang')) {
    group = 'loot';
  } else if (rarity === 'legendary' || rarity === 'epic' || type === 'level_up' || type === 'achievement') {
    group = 'big';
  }

  return pickClip(group, `${group}:${type}:${rarity}:${moment?.key || moment?.title || ''}`);
}
